import { createContext, Dispatch, SetStateAction } from "react";

import { IOption } from "@digital-services/ui";

export type FO = IOption | null;

export interface IResourcesContext {
  resourceTypeFilter: FO;
  productFamilyNameFilter: FO;
  ownerFilter: FO;
  relationshipFilter: FO;
  setResourceTypeFilter: Dispatch<SetStateAction<FO>>;
  setProductFamilyNameFilter: Dispatch<SetStateAction<FO>>;
  setOwnerFilter: Dispatch<SetStateAction<FO>>;
  setRelationshipFilter: Dispatch<SetStateAction<FO>>;

  searchQuery: string; // may include string value with `;` or `,` separated and whitespaces
  setSearchQuery: Dispatch<SetStateAction<string>>;
  searchHasError: boolean;
  setSearchHasError: Dispatch<SetStateAction<boolean>>;
}

export const ResourcesContext = createContext<IResourcesContext>({
  resourceTypeFilter: null,
  productFamilyNameFilter: null,
  ownerFilter: null,
  relationshipFilter: null,
  setResourceTypeFilter: () => {},
  setProductFamilyNameFilter: () => {},
  setOwnerFilter: () => {},
  setRelationshipFilter: () => {},

  searchQuery: "",
  setSearchQuery: () => {},
  searchHasError: false,
  setSearchHasError: () => {}
});
